<template>
  <div
    class="tw:grid tw:transition-all tw:duration-500 tw:ease-in-out tw:w-full"
    :class="isVisible ? 'tw:grid-rows-[1fr]' : 'tw:grid-rows-[0fr]'"
  >
    <div
      class="tw:overflow-hidden tw:transition-opacity tw:duration-500"
      :class="isVisible ? 'tw:opacity-100' : 'tw:opacity-0'"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isVisible: boolean;
}>();
</script>
